<script setup>
import { useI18n } from 'vue-i18n';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

defineProps({
  src: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  // Optional already-translated label. Falls back to the default profile picture label.
  label: {
    type: String,
    default: '',
  },
  // Optional already-translated hint shown under the picture.
  hint: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change', 'delete']);

const { t } = useI18n();

const updateProfilePicture = e => {
  emit('change', e);
};

const deleteProfilePicture = () => {
  emit('delete');
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-sm font-medium text-ash-900">
      {{ label || t('PROFILE_SETTINGS.FORM.PICTURE') }}
    </span>
    <Avatar
      :src="src || ''"
      :name="name || ''"
      :size="72"
      allow-upload
      @upload="updateProfilePicture"
      @delete="deleteProfilePicture"
    />
    <p v-if="hint" class="text-xs text-ash-700 max-w-md">
      {{ hint }}
    </p>
  </div>
</template>
